<template>
  <!-- sidebar-wrapper -->
  <nav id="sidebar" class="sidebar-wrapper sidebar-dark">
    <div class="sidebar-content">
      <div class="sidebar-brand">
        <router-link to="/">Asakeeb</router-link>
      </div>

      <ul class="sidebar-menu border-t border-white/10" data-simplebar style="height: calc(100% - 70px);">
        <li :class="activeIndex === '/' ? 'active' : ''">
          <router-link to="/"><i class="mdi mdi-chart-bell-curve-cumulative me-2"></i>الرئيسية</router-link>
        </li>

        <li class="sidebar-dropdown"
          :class="['/allUserss', '/users', '/profile'].includes(activeIndex) ? 'active' : ''">
          <router-link to="" @click="submenu(menuOpen === '/allUserss' ? '' : '/allUserss')"><i
              class="mdi mdi-account-edit me-2"></i>المستخدمون</router-link>
          <div class="sidebar-submenu" :class="['/allUserss', '/users', '/profile'].includes(menuOpen) ? 'block' : ''">
            <ul>
              <li :class="activeIndex === '/users' ? 'active' : ''"><router-link to="/users">الكل</router-link></li>
              <li :class="activeIndex === '/profile' ? 'active' : ''"><router-link to="/profile"> الحسابات</router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- 
        <li class="sidebar-dropdown" :class="['/blogs', '/blog', '/blog-detail'].includes(activeIndex) ? 'active' : ''">
          <router-link to="" @click="submenu(menuOpen === '/blogs' ? '' : '/blogs')"><i
              class="mdi mdi-post-outline me-2"></i>Blog</router-link>
          <div class="sidebar-submenu" :class="['/blogs', '/blog', '/blog-detail'].includes(menuOpen) ? 'block' : ''">
            <ul>
              <li :class="activeIndex === '/blog' ? 'active' : ''"><router-link to="/blog">Blogs</router-link></li>
              <li :class="activeIndex === '/blog-detail' ? 'active' : ''"><router-link to="/blog-detail">Blog
                  Detail</router-link></li>
            </ul>
          </div>
        </li> -->

        <!-- <li :class="activeIndex === '/explore-property' ? 'active' : ''">
          <router-link to="/explore-property"><i class="mdi mdi-home-city me-2"></i>Explore Properties</router-link>
        </li>

        <li :class="activeIndex === '/favorite-property' ? 'active' : ''">
          <router-link to="/favorite-property"><i class="mdi mdi-home-heart me-2"></i>Favorite Properties</router-link>
        </li>

        <li :class="activeIndex === '/add-property' ? 'active' : ''">
          <router-link to="/add-property"><i class="mdi mdi-home-plus me-2"></i>Add Properties</router-link>
        </li>

        <li :class="activeIndex === '/chat' ? 'active' : ''">
          <router-link to="/chat"><i class="mdi mdi-chat-outline me-2"></i>Chat</router-link>
        </li> -->

        <li :class="activeIndex === '/login' ? 'active' : ''">
          <router-link to="/login"><i class="mdi mdi-chart-bell-curve-cumulative me-2"></i>دخول</router-link>
        </li>

        <!-- <li class="sidebar-dropdown"
          :class="['/pages', '/starter', '/faqs', '/pricing', '/review', '/privacy', '/terms'].includes(activeIndex) ? 'active' : ''">
          <router-link to="" @click="submenu(menuOpen === '/pages' ? '' : '/pages')"><i
              class="mdi mdi-file-document-outline me-2"></i>Pages</router-link>
          <div class="sidebar-submenu"
            :class="['/pages', '/starter', '/faqs', '/pricing', '/review', '/privacy', '/terms'].includes(menuOpen) ? 'block' : ''">
            <ul>
              <li :class="activeIndex === '/starter' ? 'active' : ''"><router-link to="/starter">Starter</router-link>
              </li>
              <li :class="activeIndex === '/faqs' ? 'active' : ''"><router-link to="/faqs">FAQs</router-link></li>
              <li :class="activeIndex === '/pricing' ? 'active' : ''"><router-link to="/pricing">Pricing</router-link>
              </li>
              <li :class="activeIndex === '/review' ? 'active' : ''"><router-link to="/review">Review</router-link></li>
              <li :class="activeIndex === '/privacy' ? 'active' : ''"><router-link to="/privacy">Privacy
                  Policy</router-link></li>
              <li :class="activeIndex === '/terms' ? 'active' : ''"><router-link to="/terms">Term &
                  Condition</router-link></li>
            </ul>
          </div>
        </li> -->
        <!-- <li :class="activeIndex === '/' ? 'active' : ''"><router-link to="/login">دخول</router-link></li> -->


        <!-- <li class="sidebar-dropdown"
          :class="['/authentication', '/login', '/signup', '/signup-success', '/reset-password', '/lock-screen'].includes(activeIndex) ? 'active' : ''">
          <router-link to="" @click="submenu(menuOpen === '/authentication' ? '' : '/authentication')"><i
              class="mdi mdi-login me-2"></i>Authentication</router-link>
          <div class="sidebar-submenu"
            :class="['/authentication', '/login', '/signup', '/signup-success', '/reset-password', '/lock-screen'].includes(menuOpen) ? 'block' : ''">
            <ul>
              <li :class="activeIndex === '/login' ? 'active' : ''"><router-link to="/login">دخول</router-link></li>
              <li :class="activeIndex === '/signup' ? 'active' : ''"><router-link to="/signup">Signup</router-link></li>
              <li :class="activeIndex === '/signup-success' ? 'active' : ''"><router-link to="/signup-success">Signup
                  Success</router-link></li>
              <li :class="activeIndex === '/reset-password' ? 'active' : ''"><router-link to="/reset-password">Reset
                  Password</router-link></li>
              <li :class="activeIndex === '/lock-screen' ? 'active' : ''"><router-link
                  to="/lock-screen">Lockscreen</router-link></li>
            </ul>
          </div>
        </li> -->

        <!-- <li class="sidebar-dropdown"
          :class="['/comingsoon', '/maintenance', '/error', '/thankyou', '/miscellaneous'].includes(activeIndex) ? 'active' : ''">
          <router-link to="" @click="submenu(menuOpen === '/miscellaneous' ? '' : '/miscellaneous')"><i
              class="mdi mdi-layers me-2"></i>Miscellaneous</router-link>
          <div class="sidebar-submenu"
            :class="['/comingsoon', '/maintenance', '/error', '/thankyou', '/miscellaneous'].includes(menuOpen) ? 'block' : ''">
            <ul>
              <li :class="activeIndex === '/comingsoon' ? 'active' : ''"><router-link
                  to="/comingsoon">Comingsoon</router-link></li>
              <li :class="activeIndex === '/maintenance' ? 'active' : ''"><router-link
                  to="/maintenance">Maintenance</router-link></li>
              <li :class="activeIndex === '/error' ? 'active' : ''"><router-link to="/error">Error</router-link></li>
              <li :class="activeIndex === '/thankyou' ? 'active' : ''"><router-link to="/thankyou">Thank
                  You</router-link></li>
            </ul>
          </div>
        </li> -->

        <li
          class="relative lg:m-8 m-6 px-8 py-10 rounded-lg bg-gradient-to-b to-transparent from-slate-800 text-center">

          إعدادات

          <span
            class="mdi mdi-home-city-outline text-[160px] absolute top-1/2 -translate-y-1/2 start-0 end-0 mx-auto text-center opacity-[0.02] text-white z-0"></span>
        </li>
      </ul>
      <!-- sidebar-menu  -->
    </div>
  </nav>
  <!-- sidebar-wrapper  -->
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const menu = ref(true);
const activeIndex = computed(() => window.location.pathname);
const menuOpen = ref('');

onMounted(() => {
  menuOpen.value = activeIndex.value
  scrollToTop();
})

function submenu(item) {
  menu.value = !menu.value
  menuOpen.value = item
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

</script>

<style lang="scss" scoped></style>